import nextId from "react-id-generator"

export const links = [
    {
        id: nextId(),
        url: "#home",
        text: "home"
    },
    {
        id: nextId(),
        url: "#about",
        text: "about"
    },
    {
        id: nextId(),
        url: "#offers",
        text: "offers"
    },
    {
        id: nextId(),
        url: "#pricing",
        text: "pricing"
    },
    {
        id: nextId(),
        url: "#trainers",
        text: "trainers"
    },
    {
        id: nextId(),
        url: "#blogs",
        text: "blogs"
    },
]